export default {
  gongyu:{
    title:'房产租赁智能化解决方案',
    subtitle:'基于智能系统，提供房源查询、在线预约、签约支付等一站式租房服务，构建了一个高效、智能的租房体系，实现了高效、便捷、舒适的租房体验。',
    programs:[{
      title:'房源智能化搜索系统',
      desc:'提供在线搜房与地图找房技术，实现精确的房源定位和地图搜索功能，确保房源信息的实时更新和准确性。'
    },{
      title:'租住服务安全管理系统',
      desc:'构建安全的身份验证和电子签名系统，确保合同签署的合法性和有效性，同时通过人脸识别、智能门锁等先进的安全技术，提升入住体验。'
    },{
      title:'智能物业管理系统',
      desc:'提供数字化、可视化应用体验，打造租客APP，支持售后保修、在线租金账单缴费、在线水电费缴费、投诉建议反馈等租后应用服务。'
    },{
      title:'租房市场优化系统',
      desc:'使用大数据、云计算等科技化手段，合理分析租房群体，提升公寓的整体竞争力。'
    }],
  },
  yuanqu:{
    title:'利用IOT物联网大数据模型助力园区管理',
    subtitle:'运用IOT物联网、人工智能、大数据、云计算等前沿技术，场景化解决园区日常的管理动作，为园区数智化服务打造坚实的基础。',
    programs:[{
      title:'园区资产管理',
      desc:'让园区的固定资产数据化管理，更方便，更高效'
    },{
      title:'招商引资管理',
      desc:'线索、洽谈、签约、入住，全流程管控，不损失一个有效客户'
    },{
      title:'企业服务管理',
      desc:'帮助企业全方位服务入驻企业，更高效，更便捷 '
    },{
      title:'园区物管服务',
      desc:'物业管理、设备管理、员工管理，系统化、流程化'
    }],
    info:''
  },
  shangye:{
    title:'商管服务数字化解决方案',
    subtitle:'将复杂的业务拆解成标准化系统模块，构建可视化、专业化、多终端智慧互联、高效协作的智慧商业平台，提高市场竞争力，助力国家商业生态的智能化、高效化和安全化发展',
    programs:[{
      title:'资源管理系统',
      desc:'支持商业综合体中的各种资源位的分类管理，包括商铺、广告位等，支持按楼层、楼栋、街区等详细划分。集成业态、品类、资源位及品牌商户资源，实现精细化分类管理，提升资源配置效率和商业运营智能化水平。'
    },{
      title:'招商服务管理系统',
      desc:'与BPM系统深度集成,通过智能化和自动化的合同处理流程，实现强大的合同生命周期管理能力，提升招商管理的效率和质量。'
    },{
      title:'结算管理系统',
      desc:'通过自动化流程显著提升财务效率，支持多渠道交易核对确保数据精准，灵活的结算单模板与报表生成简化管理，实时监控功能为决策提供有力支持，全面优化资金流管理。'
    },{
      title:'资金预测系统',
      desc:'依托历史数据和市场分析精准预测现金流，全面预算规划，深入风险评估，自动生成多维财务报告，并通过数据可视化技术，使管理层洞察财务状况，优化资金运作。'
    }],
    // info:'寓信科技凭借领先的平台技术，探索“互联网+租房”的新举措，重新连接人与空间，智造安全、便捷的长租公寓管理体验。整合房地产集团各级管理需求，完成从入住到退房的全流程监管，做到住户管理、房源管理、物业服务、社区服务在一个平台上实现，提高管理效率和服务品质，解决住房租赁管理难度大，服务不及时等问题。'
  },
  yinhang:{
    title:'银行企业数字化解决方案',
    subtitle:'响应国家号召、落实国家政策、助力住房租赁企业发展、管控资金监管\n',
    challenge:[{
      icon:'https://ow-resource.gousii.com/image/solution/lanling_icon1.png',
      text:'缺乏“住房租赁”科技平台实践经验',
      subtext:'做saas平台逻辑复杂、人力成本高、耗费时间长。'
    },{
      icon:'https://ow-resource.gousii.com/image/solution/lanling_icon2.png',
      text:'资源匹配不及时，方案落地慢',
      subtext:'行业老兵成熟业务助力平台快速上线、多软硬件快速实施对接主力数字化转型。'
    }],
    programs:[{
      title:'全方位科技赋能住房租赁行业',
      desc:'银行数字化解决方案成熟、紧跟时政、深度研究国家发布最新相关政策，做最能落地的解决方案'
    },{
      title:'成熟的SaaS解决方案\n',
      desc:'行业经验丰富，对业务理解深刻，深谙平台类产品的落地之法，成熟业务助力平台快速上线、多软硬件快速实施对接主力数字化转型'
    },{
      title:'安全、可扩展',
      desc:'金融、财务报表类型、接口丰富，扩展性强，提升业财一体化建设效率'
    },{
      title:'BI数据统计展示',
      desc:'筛选业务开展落地时的关键数据，按业务场景进行有效区分，重要数据大屏展示并可根据业务需要设置阈值，实时了解项目运营情况'
    }],
    info:'寓信科技与银行企业在住房租赁行业数字化合作方案成熟，且紧跟时政，深度研究国家发布最新相关政策，只做高效落地的解决方案。'
  },
  lingshou:{
    title:'零售智链解决方案',
    subtitle:'通过全渠道融合、大数据分析、AI应用、供应链优化、CRM系统、移动电商、云计算、IoT技术、VR/AR体验及自动化等技术实现数字化转型，提升运营效率和顾客体验',
    programs:[{
      title:'- 全渠道零售系统',
      desc:'整合线上与线下购物体验，运用大数据分析来优化营销策略，并通过移动应用及社交电商提升用户互动和参与度。'
    },{
      title:'- 智能供应链与物流系统',
      desc:'采用供应链管理软件来提高库存和物流的效率，利用物联网技术实现库存管理的精确化，并通过自动化技术降低仓库作业成本。'
    },{
      title:'- 客户服务系统',
      desc:'通过CRM系统增强客户服务质量和忠诚度，运用AI技术提供个性化推荐和自动化客户服务，结合VR/AR技术打造沉浸式购物体验。'
    },{
      title:'- IOC分析系统',
      desc:'通过前沿的数据分析系统，结合AI人工智能、IOT中台、应用系统等数据模型，建立一个IOC平台的数据驾驶舱'
    }],
    info:''
  }
}